document.addEventListener("DOMContentLoaded", function() {
  const lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  let preloadedByTimer = false;

  function loadVideo(videoElement) {
    // Skip if already loaded
    if (!videoElement.classList.contains("lazy")) return;
    
    for (const source in videoElement.children) {
      const videoSource = videoElement.children[source];
      if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
        videoSource.src = videoSource.dataset.src;
      }
    }
    
    videoElement.load();
    videoElement.classList.remove("lazy");
  }

  // Timer-based preloading after 3 seconds
  setTimeout(function() {
    if (!preloadedByTimer) {
      preloadedByTimer = true;
      lazyVideos.forEach(function(video) {
        loadVideo(video);
      });
      // Disconnect observer since all videos are now loaded
      if (lazyVideoObserver) {
        lazyVideoObserver.disconnect();
      }
    }
  }, 3000);

  // Intersection Observer for visibility-based loading
  let lazyVideoObserver = null;
  
  if ("IntersectionObserver" in window) {
    lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          loadVideo(video.target);
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});